module.exports = __webpack_public_path__ + "img/thumb-collection-lopes.0cfa4351.jpg";